import React from "react";

const ParticipantCard = ({ title, subtitle, person, accentClass }) => {
  const name = person?.displayName || person?.fullName || null;
  const full = person?.fullName && person?.displayName !== person?.fullName
    ? person.fullName
    : null;

  return (
    <div className={`logs-participant-card ${accentClass || ""}`}>
      <div className="logs-participant-card__head">
        <h4>{title}</h4>
        {subtitle ? <span className="logs-participant-card__sub">{subtitle}</span> : null}
      </div>
      {!person || (!name && !person.phoneNumber) ? (
        <p className="logs-participant-card__empty">Not assigned</p>
      ) : (
        <div className="logs-participant-card__body">
          {person.imageUrl ? (
            <img
              src={person.imageUrl}
              alt=""
              className="logs-participant-card__avatar"
            />
          ) : (
            <div className="logs-participant-card__avatar logs-participant-card__avatar--placeholder">
              {(name || "?").slice(0, 1).toUpperCase()}
            </div>
          )}
          <div className="logs-participant-card__info">
            {name ? <strong>{name}</strong> : null}
            {full ? <span className="logs-participant-card__full">{full}</span> : null}
            {person.phoneNumber ? (
              <a href={`tel:${person.phoneNumber}`} className="logs-participant-card__phone">
                {person.phoneNumber}
              </a>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};

export default ParticipantCard;
